module.exports = __webpack_public_path__ + "08_face.e5c8b692.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer1/08_face.png
// module id = VV2n
// module chunks = 0